import React from 'react';

import { Heading } from '@thepuzzlers/pieces';

export const HighlightedHeading = ({ data, sx, ...props }) => {
  return (
    <Heading
      dangerouslySetInnerHTML={{ __html: data }}
      sx={{
        color: 'currentColor',
        fontFamily: 'primary.normal',
        '& > span': {
          fontFamily: 'primary.italic',
          color: 'secondary'
        },
        ...sx
      }}
      {...props}
    />
  );
};

export const HighlightedRichTextHeading = ({ children, sx, ...props }) => {
  return (
    <Heading
      sx={{
        color: 'currentColor',
        fontFamily: 'primary.normal',
        '& > span, & > em, & > strong': {
          fontFamily: 'primary.italic',
          color: 'secondary'
        },
        ...sx
      }}
      {...props}>
      {children}
    </Heading>
  );
};
